const en = {
    '/': {
        title: '{brand} & Sportsbook | Instant Withdrawals',
        description: '{brand} and sportsbook on one wallet. Slots, live casino and provably fair originals plus sports betting, with instant crypto withdrawals.',
        keywords: 'crypto casino, bitcoin casino, crypto sportsbook, bitcoin sports betting, instant crypto withdrawals, provably fair casino'
    },
    '/casino': {
        title: '{brand} Online Casino | Slots, Live Dealers & Fast Payouts',
        description: 'Slots, blackjack, roulette and live dealer tables at {brand}. Fast crypto deposits, instant withdrawals and support around the clock.',
        keywords: 'crypto casino, bitcoin casino games, online casino, crypto slots, live dealer casino, blackjack, roulette'
    },
    '/sports': {
        title: '{brand} Online Sportsbook | Crypto Sports Betting & Odds',
        description: 'Bet on sports at {brand}. Competitive odds on football, basketball & more. Live betting, secure crypto wagering & fast payouts.',
        keywords: 'crypto sportsbook, bitcoin sports betting, live betting, football odds, basketball betting, esports betting'
    },
    '/livecasino': {
        title: '{brand} Live Casino | Real Dealers, Blackjack & Roulette',
        description: 'Live blackjack, roulette, baccarat and game shows at {brand}. Real dealers, HD streams and tables open 24/7, all playable with crypto.',
        keywords: 'live casino, live dealer games, live blackjack, live roulette, live baccarat, casino game shows'
    },
    '/slots': {
        title: '{brand} Online Slots | Free Demos, RTP & Big Max Wins',
        description: 'Spin thousands of slots at {brand} from Pragmatic Play, Hacksaw Gaming and Nolimit City. Try any game free in demo mode or play with crypto.',
        keywords: 'crypto slots, bitcoin slots, online slots, video slots, megaways slots, feature buy slots'
    },
    '/vip': {
        title: '{brand} VIP Program | Exclusive Rewards & Benefits',
        description: "{brand}'s VIP program: exclusive rewards, personalised bonuses & priority support. Tailored perks for loyal players.",
        keywords: 'casino vip program, rakeback, casino loyalty rewards, high roller casino, vip tiers'
    },
    '/welcome-offer': {
        title: '{brand} Welcome Bonus Offer | Sign Up & Get Your Bonus',
        description: "Claim {brand}'s welcome bonus on your first deposit. Learn how to get started and make the most of our sign-up offer.",
        keywords: 'casino welcome bonus, crypto casino bonus, first deposit bonus, new player offer'
    },
    '/referral': {
        title: '{brand} Referral Program | Invite Friends & Earn Rewards',
        description: 'Refer friends to {brand} & earn rewards when they sign up and play. Share your link and collect bonuses for every referral.',
        keywords: 'casino referral program, refer a friend bonus, affiliate rewards'
    },
    '/promotion-page': {
        title: '{brand} Casino Bonuses | Promo Codes & Weekly Races',
        description: 'Every active promotion at {brand} in one place: welcome offer, weekly races and tournaments. Check the current terms and claim yours.',
        keywords: 'casino promotions, crypto casino bonuses, weekly race, casino tournaments'
    },
    '/hotslots': {
        title: '{brand} Hot Slots | Most Popular Casino Slots',
        description: 'Play the hottest slot games at {brand}. Top-rated slots available with crypto.'
    },
    '/newgames': {
        title: '{brand} New Games | Latest Slot & Live Casino Releases',
        description: 'The newest slot and live casino releases at {brand}, added as providers launch them. Be among the first to play them with crypto.'
    },
    '/populargames': {
        title: '{brand} Popular Games | Most Played Slots & Live Tables',
        description: 'See what players are playing most at {brand} right now: the top slots, live tables and game shows in one list, all playable with crypto.'
    },
    '/gameshows': {
        title: '{brand} Game Shows | Crazy Time, Mega Wheel & Live Hosts',
        description: 'Play Crazy Time, Mega Wheel, Monopoly Live and more game shows at {brand}. Real hosts, live rounds and big multipliers, 24/7 with crypto.'
    },
    '/table_games': {
        title: '{brand} Table Games | Blackjack, Roulette & Baccarat',
        description: 'Play blackjack, roulette, baccarat and more table games at {brand}. All available with crypto.'
    },
    '/hotlive': {
        title: '{brand} Popular Live Casino | Top Live Casino Games',
        description: 'The most popular live casino games at {brand}. Play with real dealers in real time.'
    },
    '/featurebuyin': {
        title: '{brand} Bonus Buy Slots | Buy the Bonus Round Instantly',
        description: 'Buy straight into the bonus round at {brand}. Bonus buy slots from Pragmatic Play, Hacksaw Gaming, Nolimit City and more, playable with crypto.'
    },
    '/originals': {
        title: '{brand} Originals | Crash, Plinko & Provably Fair Games',
        description: "Play {brand} Originals: Crash, Plinko, Keno, Dragon's Tower and more. In-house provably fair games with results you can verify yourself."
    }
};
export default en;
